// Specific Volume units with conversion factors to cubic meter per kilogram (m³/kg)
export const specificVolumeUnits = [
  { id: 'cubic-meter-per-kilogram', name: 'Cubic Meter/Kilogram', symbol: 'm³/kg', plural: 'Cubic Meters/Kilogram', factor: 1 },
  { id: 'cubic-centimeter-per-gram', name: 'Cubic Centimeter/Gram', symbol: 'cm³/g', plural: 'Cubic Centimeters/Gram', factor: 0.001 },
  { id: 'liter-per-kilogram', name: 'Liter/Kilogram', symbol: 'L/kg', plural: 'Liters/Kilogram', factor: 0.001 },
  { id: 'liter-per-gram', name: 'Liter/Gram', symbol: 'L/g', plural: 'Liters/Gram', factor: 1 },
  { id: 'cubic-foot-per-kilogram', name: 'Cubic Foot/Kilogram', symbol: 'ft³/kg', plural: 'Cubic Feet/Kilogram', factor: 0.028316846592 },
  { id: 'cubic-foot-per-pound', name: 'Cubic Foot/Pound', symbol: 'ft³/lb', plural: 'Cubic Feet/Pound', factor: 0.062427960576 },
  { id: 'gallon-us-per-pound', name: 'Gallon (US)/Pound', symbol: 'gal/lb', plural: 'Gallons (US)/Pound', factor: 0.00834540445 },
  { id: 'gallon-uk-per-pound', name: 'Gallon (UK)/Pound', symbol: 'gal/lb', plural: 'Gallons (UK)/Pound', factor: 0.01002241 },
  { id: 'cubic-inch-per-pound', name: 'Cubic Inch/Pound', symbol: 'in³/lb', plural: 'Cubic Inches/Pound', factor: 0.000036127292 },
];

export const popularSpecificVolumeConversions = [
  { from: 'cubic-meter-per-kilogram', to: 'cubic-foot-per-pound' },
  { from: 'cubic-foot-per-pound', to: 'cubic-meter-per-kilogram' },
  { from: 'liter-per-kilogram', to: 'cubic-foot-per-pound' },
  { from: 'cubic-centimeter-per-gram', to: 'cubic-meter-per-kilogram' },
  { from: 'gallon-us-per-pound', to: 'liter-per-kilogram' },
  { from: 'cubic-meter-per-kilogram', to: 'liter-per-kilogram' },
];

export const getUnitById = (id) => specificVolumeUnits.find(unit => unit.id === id);

export const convertSpecificVolume = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} (${fromUnit.symbol}) to ${toUnit.plural.toLowerCase()} (${toUnit.symbol}) and learn the conversion formula.`;
};
